import React, { ReactElement, useEffect, useState } from "react";

const HespStream = ({ settings }): ReactElement => {
  const [_streamId, _setStreamId] = useState<string>("");

  useEffect(() => {
    if (!settings) return;
    _setStreamId(settings.videoId);
    addVideoScript();
  }, [settings?.videoId]);

  const addVideoScript = () => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://cdn.hesp.live/player/embed.js";
    document.getElementsByTagName("head")[0].appendChild(script);
  };
  return (
    <div
      data-hesp-live-id={_streamId}
      className="d-flex justify-content-center align-items-center h-100 mx-auto"></div>
  );
};

export default HespStream;
